import React from 'react'
import { ControlLabel } from '../label/Label'
import InputMaskComp from '../inputs/InputMaskComp'
import './labeledInput.scss'

const LabeledInputMask = ({
  classNameBox,
  idLabel,
  required,
  onChange,
  ...propsInput
}) => {
  return (
    <div className={`flex-container ${classNameBox}`}>
      <ControlLabel id={idLabel} required={required} />
      <div className="control-input">
        <InputMaskComp onChange={onChange} {...propsInput} />
      </div>
    </div>
  )
}

export default LabeledInputMask
